<script setup>
import { ref, onMounted, computed } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useRequestsStore } from "@/stores/storeRequests";
import BaseTooltip from "@/components/ui/BaseTooltip.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";

const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();

const typePrize = {
	guaranteed: "Гарантированный",
	monthly_emoji: "Ежемесячный",
	monthly_fillword: "Ежемесячный",
	weekly_anorak: "Еженедельный",
	weekly_shoper: "Еженедельный",
	weekly: "Еженедельный",
	weekly_certificate: "Еженедельный",
	weekly_ticket: "Еженедельный",
};

const prizes = ref([
	{
		id: 1,
		title: "Анорак",
		type: "Еженедельный",
		format: "real_prize",
		image: new URL("@/assets/img/prizes/gift_1.webp", import.meta.url).href,
		description: "Разыгрывается еженедельно — среди пользователей, загрузивших чек.",
		greeting_text: ""
	},
	{
		id: 2,
		title: "Шоппер",
		type: "Еженедельный",
		format: "real_prize",
		image: new URL("@/assets/img/prizes/gift_2.webp", import.meta.url).href,
		description: "Разыгрывается еженедельно — среди пользователей, загрузивших чек.",
		greeting_text: ""
	},
	{
		id: 3,
		title: "Билет в Третьяковскую галерею",
		type: "weekly_anorak",
		format: "real_prize",
		image: new URL("@/assets/img/prizes/gift_3.webp", import.meta.url).href,
		description: `
			<h4>Разыгрывается:</h4>
			<ul>
				<li>еженедельно — среди пользователей, загрузивших чек;</li>
				<li>ежемесячно — среди участников, загрузивших чек и прошедших викторину «Шедевры в эмодзи» или игру «Арт-филворд».</li>
			</ul>
		`,
		greeting_text: ""
	},
	{
		id: 4,
		title: "Сертификат Яндекс Афиша ",
		type: "weekly_anorak",
		format: "real_prize",
		image: new URL("@/assets/img/prizes/gift_4.webp", import.meta.url).href,
		description: `
			<h4>Разыгрывается:</h4>
			<ul>
				<li>еженедельно — среди пользователей, загрузивших чек;</li>
				<li>ежемесячно — среди участников, загрузивших чек и прошедших викторину «Шедевры в эмодзи» или игру «Арт-филворд».</li>
			</ul>
		`,
		greeting_text: ""
	},
	{
		id: 5,
		title: "Стикерпак в Телеграм",
		type: "weekly_anorak",
		format: "real_prize",
		image: new URL("@/assets/img/prizes/gift_5.webp", import.meta.url).href,
		description: "Гарантированный приз за регистрацию на сайте",
		greeting_text: ""
	},
]);

const stripTags = (html) =>  {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

const isMobile = computed(() => storeSettings.widthWindow <= 480);

onMounted(async () => {
	// prizes.value = await storeRequests.getPrizes();
	
});
</script>
<template>
	<section class="prizes section" id="prizes">
		<div class="container">
			<h2 class="prizes__title title2">Призы</h2>
			<div class="prizes__slider">
				<Swiper
					:modules="[Navigation, Pagination]"
					:observer="true"
					:observeParents="true"
					:observeSlideChildren="true"
					:resizeObserver="true"
					:navigation="{
						nextEl: '.button-next',
						prevEl: '.button-prev',
					}"
					:pagination="{
						el: '.pagination',
					}"
					:breakpoints="{
						320: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						577: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						769: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
						1201: {
							slidesPerView: 3,
							spaceBetween: 32,
						},
					}"
					class="prizes__swiper"
				>
					<SwiperSlide :class="['prizes-slide']" v-for="prize in prizes" :key="prize.id">
						<BaseTooltip class="prizes-slide__btn-info" placement="left-bottom" :content="prize.description">
							<svg width="24" height="24"><use href="#info"></use></svg>
						</BaseTooltip>
						<div class="prizes-slide__image">
							<img class="full-img" width="692" height="692" :src="prize.image" :alt="prize.title" />
						</div>
						<div class="prizes-slide__content">
							<h3 class="prizes-slide__title">{{ prize.title }}</h3>
						</div>
					</SwiperSlide>
					<div class="prizes__pagination pagination"></div>
				</Swiper>
				<div class="prizes__controller controller">
					<div class="prizes__button-prev button-prev swiper-btn">
						<svg width="30" height="30"><use href="#prev"></use></svg>
					</div>
					<div class="prizes__button-next button-next swiper-btn">
						<svg width="30" height="30"><use href="#next"></use></svg>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
@use "@/assets/scss/blocks/swiper";
.prizes {
}

.prizes__title {
	margin-bottom: 2rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 3rem;
	}
}
.prizes__slider {
	position: relative;
	padding: 0 5.5rem;
	@media (max-width: vars.$mn) {
		padding: 0;
	}
}
.prizes__swiper {
}
.prizes-slide {
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 1.6rem;
	height: auto;
	border: 1px solid var(--border-inverse-4);
	border-radius: var(--border-radius);
	padding: 2.4rem 0rem 4rem;
	overflow: hidden;
	@media (max-width: vars.$x480) {
		padding: 1.2rem 0rem 3rem;
		gap: 2rem;
	}
}
.prizes-slide__btn-info {
	position: absolute;
	width: 2.4rem;
	height: 2.4rem;
	top: 2.4rem;
	right: 2.4rem;
	@media (max-width: vars.$x480) {
		top: 0.7rem;
		right: 0.7rem;
	}
	svg {
		width: 100%;
		height: 100%;
		stroke: transparent;
	}
	:deep(h4) {
		font-weight: 700;
		font-size: 1.6rem;
		line-height: 140%;
		color: var(--text-accent-1-100);
	}
	:deep(ul) {
		list-style-type: disc;
		padding-left: 15px;		
	}
}
.prizes-slide__image {
	width: 48rem;
	@media (max-width: vars.$mn) {
		width: 30rem;
	}
	@media (max-width: vars.$xx) {
		width: 28.3rem;
	}
	img {
		aspect-ratio: 1/1;
	}
}

.prizes-slide__content {
	display: flex;
	align-items: center;
	flex-direction: column;
	height: 100%;
	gap: 1.7rem;
	@media (max-width: vars.$x480) {
		gap: 2rem;
	}
}
.prizes-slide__info {
	display: flex;
	align-items: center;
	gap: 0.8rem;
	span {
		border: 1px solid var(--border-inverse-3);
		border-radius: 0.8rem;
		padding: 0.9rem 1.6rem;

		font-weight: 500;
		font-size: 2.4rem;
		line-height: 120%;
		text-align: center;
		color: #0c4ca3;
		@media (max-width: vars.$x480) {
			font-size: 1.8rem;
			padding: 9px 16px;
		}
	}
}
.prizes-slide__title {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	text-align: center;
	// max-width: 31rem;
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.prizes__pagination {
	display: none;
	margin-top: 4.2rem;
	@media (max-width: vars.$mn) {
		display: flex;
	}
}
.prizes__controller {
	width: 107%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: space-between;
	z-index: 1;
	@media (max-width: vars.$l) {
		width: 105%;
	}
	@media (max-width: vars.$mn) {
		display: none;
	}	
}
</style>
